import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: 'How is this different from the CO detector I already have?',
  a: "Standard ceiling detectors stay silent until CO reaches 70 to 150 PPM — near-fatal concentrations. They're designed to detect life-threatening emergencies, not protect you from chronic low-level exposure. AirGuard Pro alerts you at 30+ PPM, shows you the exact reading in real time, and uses a 4-stage color system so you can see the threat level from across the room. It's the difference between a smoke alarm and a complete air monitoring system."
}, {
  q: 'Does it need batteries or professional installation?',
  a: 'No and no. Plug it into any standard wall outlet and it starts monitoring immediately. No drilling, no wiring, no electrician. It draws minimal power and runs 24/7. This is also why we recommend multiple units — one per floor, one near sleeping areas.'
}, {
  q: 'Why is this more expensive than the $25 detector at Home Depot?',
  a: "Those $25 detectors use basic semiconductor sensors that only trigger at near-fatal levels and expire in 3-5 years — often without telling you. AirGuard Pro uses a precision sensor with a 10-year lifespan, alerts at 30+ PPM, shows real-time readings on a color display, monitors temperature and humidity, and is CE & FCC certified. It's not a different version of the same thing — it's a completely different category of protection."
}, {
  q: 'What does the 3-year warranty cover?',
  a: "Everything. If your AirGuard Pro experiences any manufacturing defect or sensor issue within 3 years, we replace it. Period. The sensor itself is rated for 10 years, so the warranty covers you well within the product's reliable lifespan."
}, {
  q: 'Is it safe to use near children and pets?',
  a: "Completely. AirGuard Pro is a passive monitoring device. It doesn't emit anything — it only reads what's already in your air. It's CE and FCC certified, meaning it meets strict safety standards for home use. The plug-in design also keeps it off the floor and out of reach."
}, {
  q: 'Can I use it when I travel?',
  a: 'Yes. AirGuard Pro is compact and portable. Many of our customers travel with it for hotels, Airbnbs, and RVs. Plug it into any standard outlet and you have the same protection you have at home.'
}, {
  q: 'How loud is the alarm? Will it wake me up?',
  a: "Yes — that's the point. The audible alarm is designed to be loud enough to wake a sleeping household. Combined with the 4-stage visual color alert, you have both visual and audible warning systems working together."
}, {
  q: 'How do I know when the sensor expires?',
  a: "AirGuard Pro has a built-in sensor expiration alert. Unlike traditional detectors that show a green light long after the sensor has died, AirGuard Pro will notify you clearly when it's time for a replacement. No guessing."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-bg-primary py-5 md:py-8 px-4 sm:px-6 lg:px-8" data-id="element-48">
      <div className="max-w-[750px] mx-auto" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-50">
          <span className="text-accent-orange font-medium text-[12px] tracking-wide uppercase mb-2 block" data-id="element-51">
            FREQUENTLY ASKED QUESTIONS
          </span>
          <h2 className="text-[24px] font-bold text-text-primary" data-id="element-52">
            Questions? We've Got Answers.
          </h2>
        </motion.div>

        <div className="space-y-2" data-id="element-53">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.05
        }} className="bg-bg-card border border-border-subtle rounded-lg shadow-card overflow-hidden" data-id="element-54">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3 text-left flex justify-between items-center focus:outline-none" data-id="element-55">
                <span className="font-bold text-text-primary text-[15px] pr-6" data-id="element-56">
                  {faq.q}
                </span>
                {openIndex === i ? <Minus className="w-5 h-5 text-accent-orange flex-shrink-0" data-id="element-57" /> : <Plus className="w-5 h-5 text-accent-orange flex-shrink-0" data-id="element-58" />}
              </button>
              <AnimatePresence data-id="element-59">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-60">
                    <div className="px-4 pb-3 text-text-secondary text-[14px] leading-[1.45]" data-id="element-61">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}